import React from "react";
import Alert from "react-bootstrap/Alert";

/**
 * Simple fallback UI displayed by DataErrorBoundary.
 *
 * Per Section 7 (Error Handling) of the developer guide we keep the UI
 * lightweight and use React‑Bootstrap components for consistency.
 */
const ErrorComponent: React.FC = () => (
  <Alert variant="danger" className="m-3">
    Something went wrong. Please try again later.
  </Alert>
);

export default ErrorComponent;
